import React from "react";
import style from "./style.module.css";
import { images } from "../../../../assets/images";

const TagLine = ({ text = "give some text" }) => {
  return (
    <div className={style.container}>
      {text}
      <div className={style.avasify}>
        Avasify{" "}
        <span>
          <img src={images.fire} alt="fire icon" />
        </span>
      </div>
    </div>
  );
};

export default TagLine;
